<template>
  <div>欢迎</div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
</style>